export const isBase64 = data => {
  const base64Regex =
    /^data:image\/(png|jpg|jpeg|gif|webp);base64,([A-Za-z0-9+/=])+$/

  return base64Regex.test(data)
}
